import { call, put, takeEvery } from 'redux-saga/effects'

// Helper for api errors
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
let clientApi = axiosApi()

// Our login constants
import {
  RESETPASSWORD_REQUESTING,
  RESETPASSWORD_SUCCESS,
  RESETPASSWORD_ERROR,
  RESETPASSWORD_URL,
} from './constants'

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function resetPasswordApi (formData) {
  const request = clientApi.post(RESETPASSWORD_URL, 
    formData
  );
  return handleRequest(request);
}

function* resetPasswordFlow (action) {
  try {
    const { formData } = action
    var result = yield call(resetPasswordApi, formData)
    if (result.code != 200) {
      yield put({ type: RESETPASSWORD_ERROR, error: result.message })
    } else {
      yield put({ type: RESETPASSWORD_SUCCESS, message: result.message })
    }
    
  } catch (error) {
    // error? send it to redux
    yield put({ type: RESETPASSWORD_ERROR, error })
  }
}

// Our watcher (saga).  It will watch for many things.
function* activeAccWatcher () {
  yield takeEvery(RESETPASSWORD_REQUESTING, resetPasswordFlow)
}

export default activeAccWatcher



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPassword/sagas.js